import { useTheme } from "@mui/material";
import { useGoalsRightOptional } from "web_myplann/Api/Rights/RightsProvider";

export const useSheetBottomSpacing = (fallback: number): number | string => {
	const { bottomSpacing } = useTheme();
	const hasGoalsRight = useGoalsRightOptional();

	return hasGoalsRight ? bottomSpacing.sheet : fallback;
};
